import reactGA from 'react-ga4';

const SpyGA = (Categoria, Accion, Ref) => {
  // 1. IMMEDIATE TRACKING (for Clicked)
  if (Categoria === 'Clicked') {
    SpyOld(Categoria, Accion);
    console.log('Analytics: Click Tracked');
    return; // Stop here
  }

  // 2. VISIBILITY TRACKING (for GoOver)
  if (Categoria === 'GoOver' && Ref && Ref.current) {
    const Element = Ref.current;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          SpyOld(Categoria, Accion);
          console.log('Analytics: Visibility Tracked');

          // Disconnect after tracking once to save memory and prevent duplicates
          observer.unobserve(entry.target);
          observer.disconnect();
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );
    observer.observe(Element);
  }
};

const SpyOld = (Categoria, Accion) => {
  reactGA.event({
    action: Accion,
    category: Categoria,
  });
};

export default SpyGA;
